import React from 'react';
export default function SliderRightArrow() {
    return (React.createElement("svg", { fill: "currentColor", stroke: "none", width: "15", height: "27", viewBox: "0 0 15 27" },
        React.createElement("g", { fillRule: "evenodd" },
            React.createElement("path", { fillRule: "nonzero", d: "M.198 25.926l1.06 1.06 13.259-13.258L1.258.47.198 1.53l12.197 12.198z" }))));
}
//# sourceMappingURL=sliderRightArrow.js.map